import React from "react";
import { Button } from "@/components/ui/button";
import { Mic, Square, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { useVoiceDictation } from "@/hooks/useVoiceDictation";

interface VoiceInputButtonProps {
  /** Anropas med den transkriberade texten */
  onText: (text: string) => void;
  disabled?: boolean;
  compact?: boolean;
  className?: string;
}

/**
 * Mikrofonknapp: spela in, texten skrivs in i fältet. Ljudet sparas aldrig.
 */
export const VoiceInputButton: React.FC<VoiceInputButtonProps> = ({
  onText,
  disabled = false,
  compact = false,
  className,
}) => {
  const { isSupported, isRecording, isTranscribing, toggle } = useVoiceDictation(onText);
  if (!isSupported) return null;

  const iconClass = compact ? "h-3 w-3 mr-1" : "h-4 w-4 mr-1.5";

  return (
    <Button
      type="button"
      variant={isRecording ? "destructive" : "outline"}
      size="sm"
      onClick={toggle}
      disabled={disabled || isTranscribing}
      className={cn(compact && "h-7", className)}
      aria-label={isRecording ? "Stoppa inspelning" : "Tala in text"}
      title="Tala in text – AI:n skriver ut det du säger"
    >
      {isTranscribing ? (
        <Loader2 className={cn("animate-spin", iconClass)} />
      ) : isRecording ? (
        <Square className={cn("animate-pulse", iconClass)} />
      ) : (
        <Mic className={iconClass} />
      )}
      {isTranscribing ? "Tolkar…" : isRecording ? "Stoppa" : "Tala in"}
    </Button>
  );
};

export default VoiceInputButton;
